import {
    Eye, FileText, Trash, UploadCloudIcon, CreditCard, Shield, Car, Globe, Hash, Building, UserCheck
} from "lucide-react";
import { Input } from "../../../components/ui/input";
import { Upload as AntUpload, Image } from "antd";
import { Button } from "../../../components/ui/button";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { cn } from "../../../utils/tailwindUtils";
import ToastMsg from "../../../components/common/ToastMsg";
import useApiMethods from "../../../lib/useApiMethods";
import { EMPLOYEE_CANDIDATE_DOC, EMPLOYEE_INTERN_DOC, EMPLOYEEDOC } from "../../../constants/api";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";

const default_educational_document = [
    { levels_of_education: undefined, certificate_no: "", certificate_document: [], department: "", grade: "" },
    { levels_of_education: undefined, certificate_no: "", certificate_document: [], department: "", grade: "" },
    { levels_of_education: undefined, certificate_no: "", certificate_document: [], department: "", grade: "" },
]

const default_professional_document = [
    {
        company_name: "",
        designation: "",
        start_date: "",
        end_date: "",
        experience: "",
        document_name: "",
        document: []
    }
]

const DocumentDetailsContent = forwardRef(({ employeeID, url = "" }, ref) => {
    const { fetch, update } = useApiMethods()
    const location = useLocation()
    console.log(location.pathname);

    url = location.pathname === '/employee/viewDetails' ?
        EMPLOYEEDOC : location.pathname === '/employee/onboarding/viewDetails' ?
            EMPLOYEE_CANDIDATE_DOC : location.pathname === '/intern/onboarding/viewDetails' ?
                EMPLOYEE_INTERN_DOC : '' // updating the url based on the route

    console.log(url);


    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState(
        {
            employee_document: {
                aadhar_no: "",
                aadhar_document: [],
                esic_no: "",
                esic_document: [],
                driving_licence: "",
                driving_licence_document: [],
                passport_no: "",
                passport_document: [],
                pan: "",
                pan_document: [],
                insurance_company_name: "",
                uan: "",
                uan_document: [],
                policy_no: "",
                insurance_document: [],
            },
            educational_document: default_educational_document.map(obj => ({ ...obj })),
            professional_document: default_professional_document.map(obj => ({ ...obj })),
        }
    );

    const handleFileChange = (field, file) => {
        setFormData(prev => ({
            ...prev,
            employee_document: {
                ...prev.employee_document,
                [field]: file ? [file] : [] // Store as array to match your save logic
            }
        }));
    };

    const handleRemoveFile = (field) => {
        setFormData(prev => ({
            ...prev,
            employee_document: {
                ...prev.employee_document,
                [field]: [] // Set to empty array instead of null
            }
        }));
    };

    // Remove file extension (for profile name)
    const removeFileExtension = (filename) => {
        return filename.replace(/\.[^/.]+$/, "");
    };

    // Date validation
    const isValidDate = (date) => {
        return date && !isNaN(new Date(date).getTime());
    };

    const assignDocuments = (datas) => {
        if (datas && Object.keys(datas).length > 0) {

            if (datas.professional_document?.length > 0) {
                datas.professional_document?.forEach(item => {
                    if (item.start_date || item.end_date) {
                        if (item.start_date) {
                            item.start_date = dayjs(item.start_date, "YYYY-MM-DD")
                        }
                        if (item.end_date) {
                            item.end_date = dayjs(item.end_date, "YYYY-MM-DD")
                        }
                    }
                })
            }

            setFormData((prevFormData) => ({
                ...prevFormData,
                employee_document: {
                    ...prevFormData.employee_document,
                    id: datas?.employee_document?.id,
                    employee: datas?.employee_document?.employee,
                    aadhar_no: datas?.employee_document?.aadhar_no ? datas?.employee_document?.aadhar_no : "",
                    aadhar_document: datas?.employee_document?.aadhar_document ? [datas?.employee_document?.aadhar_document] : [], // Store as array
                    esic_no: datas?.employee_document?.esic_no ? datas?.employee_document?.esic_no : "",
                    esic_document: datas?.employee_document?.esic_document ? [datas?.employee_document?.esic_document] : [], // Store as array
                    driving_licence: datas?.employee_document?.driving_licence ? datas?.employee_document?.driving_licence : "",
                    driving_licence_document: datas?.employee_document?.driving_licence_document ? [datas?.employee_document?.driving_licence_document] : [], // Store as array
                    passport_no: datas?.employee_document?.passport_no ? datas?.employee_document?.passport_no : "",
                    passport_document: datas?.employee_document?.passport_document ? [datas?.employee_document?.passport_document] : [], // Store as array
                    pan: datas?.employee_document?.pan ? datas?.employee_document?.pan : "",
                    pan_document: datas?.employee_document?.pan_document ? [datas?.employee_document?.pan_document] : [], // Store as array
                    insurance_company_name: datas?.employee_document?.insurance_company_name ? datas?.employee_document?.insurance_company_name : "",
                    uan: datas?.employee_document?.uan ? datas?.employee_document?.uan : "",
                    uan_document: datas?.employee_document?.uan_document ? [datas?.employee_document?.uan_document] : [], // Store as array
                    policy_no: datas?.employee_document?.policy_no ? datas?.employee_document?.policy_no : "",
                    insurance_document: datas?.employee_document?.insurance_document ? [datas?.employee_document?.insurance_document] : [], // Store as array
                },
                educational_document: datas?.educational_document?.length > 0 ?
                    [...datas?.educational_document, { levels_of_education: "", certificate_no: "", certificate_document: [], department: "", grade: "" },]
                    : default_educational_document.map(obj => ({ ...obj })),
                professional_document: datas?.professional_document?.length > 0 ?
                    [...datas?.professional_document] : default_professional_document.map(obj => ({ ...obj })),
            }));
        }
    }

    const getDocDetailsById = async (id) => {
        setLoading(true)
        try {
            const apiData = await fetch(url, { id: id });
            if (apiData?.status === "success" && apiData.data) {
                const employeeData = apiData.data.result[0];
                assignDocuments({ ...employeeData });
            }
        } catch (error) {
            console.error('Error fetching employee details:', error);
            ToastMsg('error', error.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (employeeID) {
            getDocDetailsById(employeeID)
        }
    }, [employeeID])

    useImperativeHandle(ref, () => ({
        handleSaveDocDetails: async () => {
            // First validate all fields before processing
            const validationErrors = [];

            // Validate employee document fields
            const fieldsToValidate = [
                { label: 'Aadhar Card No', value: formData.employee_document.aadhar_no },
                { label: 'ESIC No', value: formData.employee_document.esic_no },
                { label: 'Driving License', value: formData.employee_document.driving_licence },
                { label: 'Passport No', value: formData.employee_document.passport_no },
                { label: 'PAN No', value: formData.employee_document.pan },
                { label: 'UAN No', value: formData.employee_document.uan },
                { label: 'Policy Number', value: formData.employee_document.policy_no }
            ];

            fieldsToValidate.forEach(field => {
                if (field.value && !validateField(field.label, field.value)) {
                    validationErrors.push(`${field.label} is invalid`);
                }
            });

            // If there are validation errors, show message and return false
            if (validationErrors.length > 0) {
                ToastMsg('error', `Please fix the following errors: ${validationErrors.join(', ')}`);
                return false;
            }

            const modifiedProfInfo = {
                employe_document: { ...formData.employee_document }, // Main key for backend (without 'e')
                educational_document: formData.educational_document.map(obj => ({ ...obj })),
                professional_document: formData.professional_document.map(obj => ({ ...obj })),
            };

            // Process employee documents
            if (Object.keys(modifiedProfInfo.employe_document).length > 0) {
                for (var key in modifiedProfInfo.employe_document) {
                    if (key.includes("document")) {
                        const file = modifiedProfInfo.employe_document[key];

                        // Check if file exists as array with File object
                        if (file && Array.isArray(file) && file.length > 0 && file[0] instanceof File) {
                            modifiedProfInfo["employe_document"][key] = file[0].name; // Use employe_document for JSON
                            modifiedProfInfo[`employee_document__${key}`] = file[0]; // Use employee_document__ for files (with 'e')
                        }
                        // Handle the case where file is stored as object with originFileObj
                        else if (file && typeof file === 'object' && file.originFileObj instanceof File) {
                            modifiedProfInfo["employe_document"][key] = file.name; // Use employe_document for JSON
                            modifiedProfInfo[`employee_document__${key}`] = file.originFileObj; // Use employee_document__ for files (with 'e')
                        }
                        // Handle string URLs from API (existing documents)
                        else if (file && Array.isArray(file) && file.length > 0 && typeof file[0] === 'string') {
                            modifiedProfInfo["employe_document"][key] = file[0]; // Use employe_document for JSON
                        }
                        else {
                            modifiedProfInfo["employe_document"][key] = null; // Use employe_document for JSON
                        }
                    }
                }
            }

            // Process educational documents
            modifiedProfInfo.educational_document = modifiedProfInfo.educational_document?.filter(row =>
                row.levels_of_education || row.certificate_no ||
                ((row.certificate_document && typeof row.certificate_document === "string")
                    || (row.certificate_document && Array.isArray(row.certificate_document) && row.certificate_document.length > 0))
                || row.department || row.grade
            );

            if (modifiedProfInfo.educational_document?.length > 0) {
                modifiedProfInfo.educational_document?.forEach(item => {
                    if (item.certificate_document && item.certificate_document?.length > 0) {
                        // Handle File objects
                        if (item.certificate_document[0] instanceof File) {
                            let imgObj = item.certificate_document[0];
                            let filename = removeFileExtension(imgObj.name);
                            item["certificate_document"] = imgObj.name;
                            modifiedProfInfo[`educational_document__${filename}`] = imgObj;
                        }
                        // Handle existing string URLs
                        else if (typeof item.certificate_document[0] === 'string') {
                            item["certificate_document"] = item.certificate_document[0];
                        }
                    } else {
                        item["certificate_document"] = null;
                    }
                })
            }

            // Process professional documents
            modifiedProfInfo.professional_document = modifiedProfInfo.professional_document?.filter(row =>
            (row.company_name || row.designation || (row.start_date && isValidDate(row.start_date)) ||
                (row.end_date && isValidDate(row.end_date)) || row.experience || row.document_name ||
                ((row.document && typeof row.document === "string") ||
                    (row.document && Array.isArray(row.document) && row.document.length > 0)))
            )

            if (modifiedProfInfo.professional_document?.length > 0) {
                modifiedProfInfo.professional_document?.forEach(item => {
                    if (item.start_date || item.end_date) {
                        if (item.start_date) {
                            item.start_date = dayjs(item.start_date).format("YYYY-MM-DD")
                        }

                        if (item.end_date) {
                            item.end_date = dayjs(item.end_date).format("YYYY-MM-DD")
                        }
                    }
                    if (item.document && item.document.length > 0) {
                        // Handle File objects
                        if (item.document[0] instanceof File) {
                            let imgObj = item.document[0];
                            let filename = removeFileExtension(imgObj.name);
                            item["document"] = imgObj.name;
                            modifiedProfInfo[`professional_document__${filename}`] = imgObj;
                        }
                        // Handle existing string URLs
                        else if (typeof item.document[0] === 'string') {
                            item["document"] = item.document[0];
                        }
                    } else {
                        item.document = null;
                    }
                })
            }

            // Prepare FormData for the API call
            const formDataToSend = new FormData();

            // Add employe_document as JSON string (main key without 'e')
            formDataToSend.append("employe_document", JSON.stringify(modifiedProfInfo.employe_document));

            // Add educational_document as JSON string (empty array)
            formDataToSend.append("educational_document", JSON.stringify(modifiedProfInfo.educational_document || []));

            // Add professional_document as JSON string (empty array)
            formDataToSend.append("professional_document", JSON.stringify(modifiedProfInfo.professional_document || []));

            formDataToSend.append("employee_id", employeeID);

            // Add file attachments - Use employee_document__ for files (with 'e')
            for (const key in modifiedProfInfo) {
                if ((key.startsWith('employee_document__') || // This should be with 'e' for files
                    key.startsWith('educational_document__') ||
                    key.startsWith('professional_document__')) &&
                    modifiedProfInfo[key] instanceof File) {
                    formDataToSend.append(key, modifiedProfInfo[key]);
                }
            }

            // console.log("Final FormData:");
            // for (let [key, value] of formDataToSend.entries()) {
            //     console.log(key, value);
            // }

            try {
                const response = await update(url, formDataToSend, true)

                if (response.status !== 'fail') {
                    console.log(response.message);
                    // ToastMsg('success', response.message)
                } else {
                    ToastMsg('error', response.message)
                }
            } catch (error) {
                ToastMsg('error', error.message)
            }
        }
    }))

    if (loading) {
        return (
            <div className="h-[calc(100vh-100px)] dark:bg-gray-900 flex items-center justify-center rounded-md">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-sidebar-primary"></div>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex justify-between items-start">
                <div>
                    <h2 className="text-md font-bold text-gray-900 dark:text-white">
                        Document Details
                    </h2>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                        Complete employee professional and personal document details
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-1 gap-6">
                <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm">
                    <div className="p-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
                            <InfoField
                                label="Aadhar Card No"
                                value={formData.employee_document.aadhar_no}
                                icon={<CreditCard className="w-4 h-4" />}
                                attachment={formData.employee_document.aadhar_document}
                                onFileChange={(file) => handleFileChange('aadhar_document', file)}
                                onRemoveFile={() => handleRemoveFile('aadhar_document')}
                                onInputChange={(value) => setFormData(prev => ({
                                    ...prev,
                                    employee_document: { ...prev.employee_document, aadhar_no: value }
                                }))}
                            />
                            <InfoField
                                label="ESIC No"
                                value={formData.employee_document.esic_no}
                                icon={<Shield className="w-4 h-4" />}
                                attachment={formData.employee_document.esic_document}
                                onFileChange={(file) => handleFileChange('esic_document', file)}
                                onRemoveFile={() => handleRemoveFile('esic_document')}
                                onInputChange={(value) => setFormData(prev => ({
                                    ...prev,
                                    employee_document: { ...prev.employee_document, esic_no: value }
                                }))}
                            />
                            <InfoField
                                label="Driving License"
                                value={formData.employee_document.driving_licence}
                                icon={<Car className="w-4 h-4" />}
                                attachment={formData.employee_document.driving_licence_document}
                                onFileChange={(file) => handleFileChange('driving_licence_document', file)}
                                onRemoveFile={() => handleRemoveFile('driving_licence_document')}
                                onInputChange={(value) => setFormData(prev => ({
                                    ...prev,
                                    employee_document: { ...prev.employee_document, driving_licence: value }
                                }))}
                            />
                            <InfoField
                                label="Passport No"
                                value={formData.employee_document.passport_no}
                                icon={<Globe className="w-4 h-4" />}
                                attachment={formData.employee_document.passport_document}
                                onFileChange={(file) => handleFileChange('passport_document', file)}
                                onRemoveFile={() => handleRemoveFile('passport_document')}
                                onInputChange={(value) => setFormData(prev => ({
                                    ...prev,
                                    employee_document: { ...prev.employee_document, passport_no: value }
                                }))}
                            />
                            <InfoField
                                label="PAN No"
                                value={formData.employee_document.pan}
                                icon={<Hash className="w-4 h-4" />}
                                attachment={formData.employee_document.pan_document}
                                onFileChange={(file) => handleFileChange('pan_document', file)}
                                onRemoveFile={() => handleRemoveFile('pan_document')}
                                onInputChange={(value) => setFormData(prev => ({
                                    ...prev,
                                    employee_document: { ...prev.employee_document, pan: value }
                                }))}
                            />
                            <InfoField
                                label="UAN No"
                                value={formData.employee_document.uan}
                                icon={<Building className="w-4 h-4" />}
                                attachment={formData.employee_document.uan_document}
                                onFileChange={(file) => handleFileChange('uan_document', file)}
                                onRemoveFile={() => handleRemoveFile('uan_document')}
                                onInputChange={(value) => setFormData(prev => ({
                                    ...prev,
                                    employee_document: { ...prev.employee_document, uan: value }
                                }))}
                            />
                        </div>

                        {/* Insurance Section */}
                        <div className="grid grid-cols-1">
                            <div className="p-4 rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-700/50 hover:bg-gray-50 dark:hover:bg-gray-700/70 transition-colors duration-200">
                                <h4 className="text-md font-semibold text-gray-700 dark:text-gray-300 mb-4 flex items-center gap-2">
                                    <FileText className="w-4 h-4" />
                                    Insurance Details
                                </h4>
                                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                    {/* Insurance Company Name */}
                                    <div className="space-y-3">
                                        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                                            Insurance Company Name
                                        </label>
                                        <Input
                                            value={formData.employee_document.insurance_company_name}
                                            onChange={(e) => setFormData(prev => ({
                                                ...prev,
                                                employee_document: {
                                                    ...prev.employee_document,
                                                    insurance_company_name: e.target.value
                                                }
                                            }))}
                                            placeholder="Enter insurance company name"
                                            className={cn(
                                                "w-full rounded-md transition-colors duration-200",
                                                "border-gray-300 dark:border-gray-600",
                                                "bg-white dark:bg-gray-700 text-gray-900 dark:text-white",
                                                "focus:border-sidebar-primary focus:ring-2 focus:ring-sidebar-primary/20",
                                                "disabled:bg-gray-100 disabled:text-gray-500 dark:disabled:bg-gray-800 dark:disabled:text-gray-400"
                                            )}
                                        />
                                    </div>

                                    {/* Policy Number with Document Upload */}
                                    <InfoField
                                        label="Policy Number"
                                        value={formData.employee_document.policy_no}
                                        icon={<FileText className="w-4 h-4" />}
                                        attachment={formData.employee_document.insurance_document}
                                        onFileChange={(file) => handleFileChange('insurance_document', file)}
                                        onRemoveFile={() => handleRemoveFile('insurance_document')}
                                        onInputChange={(value) => setFormData(prev => ({
                                            ...prev,
                                            employee_document: {
                                                ...prev.employee_document,
                                                policy_no: value
                                            }
                                        }))}
                                        flex={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
})

// Validation functions with corrected regex
const validateAadhar = (aadhar) => {
    if (!aadhar) return true; // Allow empty
    const cleaned = aadhar.replace(/\s/g, '');
    return /^\d{12}$/.test(cleaned);
};

const validateESIC = (esic) => {
    if (!esic) return true; // Allow empty
    return /^[0-9]{17}$/.test(esic);
};

const validateDrivingLicense = (dl) => {
    if (!dl) return true; // Allow empty
    // More flexible validation for Indian driving licenses
    return /^[A-Z]{1,2}[-\s]?\d{1,2}[-\s]?\d{4,}[-\s]?\d{4,7}$/.test(dl);
};

const validatePassport = (passport) => {
    if (!passport) return true; // Allow empty
    // More flexible passport validation
    return /^[A-Z][A-Z0-9]{6,8}$/.test(passport);
};

const validatePAN = (pan) => {
    if (!pan) return true; // Allow empty
    return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan);
};

const validateUAN = (uan) => {
    if (!uan) return true; // Allow empty
    const cleaned = uan.replace(/\s/g, '');
    return /^\d{12}$/.test(cleaned);
};

const validatePolicyNumber = (policy) => {
    if (!policy) return true; // Allow empty
    // More flexible policy number validation
    return /^[A-Za-z0-9\-_]{8,20}$/.test(policy);
};

export const validateField = (label, value) => {
    if (!value) return true; // Allow empty fields

    switch (label) {
        case 'Aadhar Card No':
            return validateAadhar(value);
        case 'ESIC No':
            return validateESIC(value);
        case 'Driving License':
            return validateDrivingLicense(value);
        case 'Passport No':
            return validatePassport(value);
        case 'PAN No':
            return validatePAN(value);
        case 'UAN No':
            return validateUAN(value);
        case 'Policy Number':
            return validatePolicyNumber(value);
        default:
            return true;
    }
};

const getErrorMessage = (label, value) => {
    if (!value) return '';

    switch (label) {
        case 'Aadhar Card No':
            return 'Aadhar must be exactly 12 digits';
        case 'ESIC No':
            return 'ESIC must be in format: XX-XXXXXXX-X-XXXXX';
        case 'Driving License':
            return 'Invalid driving license format (e.g., DL-04-2019-1234567)';
        case 'Passport No':
            return 'Passport must be 7-9 characters, starting with a letter';
        case 'PAN No':
            return 'PAN must be in format: ABCDE1234F (5 letters + 4 digits + 1 letter)';
        case 'UAN No':
            return 'UAN must be exactly 12 digits';
        case 'Policy Number':
            return 'Policy number must be 8-20 alphanumeric characters (may include - or _)';
        default:
            return 'Invalid format';
    }
};

// Updated InfoField component to handle both File objects and string URLs
const InfoField = ({ label, value, icon, attachment, onFileChange, onRemoveFile, onInputChange, flex = false }) => {
    // Check if attachment is a File object or a string URL
    const isFileObject = attachment && Array.isArray(attachment) && attachment.length > 0 && attachment[0] instanceof File;
    const isStringUrl = attachment && Array.isArray(attachment) && attachment.length > 0 && typeof attachment[0] === 'string';
    const hasAttachment = isFileObject || isStringUrl;

    const isValid = validateField(label, value);
    const errorMessage = !isValid && value ? getErrorMessage(label, value) : '';

    return (
        <div className={cn(
            "flex flex-col gap-3 rounded-lg border-gray-200 dark:border-gray-700 transition-colors duration-200",
            !flex ? "p-4 border bg-gray-50/50 dark:bg-gray-700/50 hover:bg-gray-50 dark:hover:bg-gray-700/70" : ''
        )}>
            <div className="flex items-center gap-3">
                {
                    !flex && (
                        <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-white dark:bg-gray-600 text-gray-600 dark:text-gray-300 shadow-sm">
                            {icon}
                        </div>
                    )
                }
                <div className="flex-1 mb-1">
                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300 block">
                        {label}
                    </label>
                </div>
            </div>

            <div className={`${flex ? 'flex gap-2' : ' space-y-2'}`}>
                <Input
                    value={value}
                    onChange={(e) => onInputChange(e.target.value)}
                    placeholder={`Enter ${label}`}
                    className={cn(
                        "w-full rounded-md transition-colors duration-200",
                        "border-gray-300 dark:border-gray-600",
                        "bg-white dark:bg-gray-700 text-gray-900 dark:text-white",
                        "focus:border-sidebar-primary focus:ring-2 focus:ring-sidebar-primary/20",
                        "disabled:bg-gray-100 disabled:text-gray-500 dark:disabled:bg-gray-800 dark:disabled:text-gray-400",
                        !isValid && value && "border-red-500 focus:border-red-500 focus:ring-red-500/20"
                    )}
                />
                {errorMessage && (
                    <p className="text-xs text-red-500">
                        {errorMessage}
                    </p>
                )}

                <div className="flex gap-2 items-center">
                    {!hasAttachment ? (
                        <AntUpload
                            accept=".doc,.docx,.pdf,image/*"
                            maxCount={1}
                            beforeUpload={() => false}
                            onChange={({ fileList }) => {
                                if (fileList.length > 0 && fileList[0].originFileObj) {
                                    onFileChange(fileList[0].originFileObj);
                                }
                            }}
                            showUploadList={false}
                            className="w-full"
                        >
                            <Button
                                type="button"
                                variant="outline"
                                size="sm"
                                className="w-full border-dashed border-gray-300 dark:border-gray-600 hover:border-blue-500 hover:bg-blue-50 dark:hover:bg-blue-900/20 dark:bg-blue-900 dark:text-white transition-colors"
                            >
                                <UploadCloudIcon className="w-4 h-4 mr-2" />
                                Upload Document
                            </Button>
                        </AntUpload>
                    ) : (
                        <div className="w-full">
                            {isFileObject && attachment[0].type?.startsWith("image/") ? (
                                // IMAGE PREVIEW for File objects
                                <div className="flex justify-between items-center gap-3 p-3 border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700">
                                    <div className="flex items-center gap-3 flex-1">
                                        <Image
                                            src={URL.createObjectURL(attachment[0])}
                                            alt="preview"
                                            width={40}
                                            height={40}
                                            className="rounded-md shadow-sm object-cover"
                                        />
                                        <span className="text-sm text-gray-700 dark:text-gray-300 truncate">
                                            {attachment[0].name?.slice(0, 15)}
                                        </span>
                                    </div>
                                    <div className="flex gap-1">
                                        <a
                                            href={URL.createObjectURL(attachment[0])}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="p-2 text-blue-600 border border-blue-200 rounded-md hover:bg-blue-50 dark:border-blue-800 dark:hover:bg-blue-900/20 transition-colors"
                                        >
                                            <Eye className="w-4 h-4" />
                                        </a>
                                        <Button
                                            size="sm"
                                            variant="outline"
                                            onClick={onRemoveFile}
                                            className="p-2 text-red-600 border-red-200 hover:bg-red-50 dark:border-red-800 dark:hover:bg-red-900/20 transition-colors"
                                        >
                                            <Trash className="w-4 h-4" />
                                        </Button>
                                    </div>
                                </div>
                            ) : (
                                // DOCUMENT PREVIEW for both File objects and string URLs
                                <div className="flex justify-between items-center gap-3 p-3 border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700">
                                    <div className="flex items-center gap-3 flex-1">
                                        <FileText className="w-8 h-8 text-blue-500" />
                                        <div className="min-w-0 flex-1">
                                            <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                                {isFileObject ?
                                                    (attachment[0].type === "application/pdf" ? "PDF Document" : "Document")
                                                    : "Uploaded Document"}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex gap-1">
                                        <a
                                            href={isFileObject ? URL.createObjectURL(attachment[0]) : attachment[0]}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="p-2 text-blue-600 border border-blue-200 rounded-md hover:bg-blue-50 dark:border-blue-800 dark:hover:bg-blue-900/20 transition-colors"
                                        >
                                            <Eye className="w-4 h-4" />
                                        </a>
                                        <Button
                                            size="sm"
                                            variant="outline"
                                            onClick={onRemoveFile}
                                            className="p-2 text-red-600 border-red-200 hover:bg-red-50 dark:border-red-800 dark:hover:bg-red-900/20 transition-colors"
                                        >
                                            <Trash className="w-4 h-4" />
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DocumentDetailsContent;